import { Constants, WidgetNames } from '@finxone-platform/shared/sys-config-types';

export const exchangeCurrencyCountryNestedWidgets = {
  continueButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Continue Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Continue',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
      },
    },
  },
};
